import { GeorefData, QueuedIntakeFileInfo, UploadData } from '../../../store/uploadStore';
import { UploadNotRestoredError } from '../../../errors/UploadNotRestoredError';
import { validateImage } from './validateImage';
import { validateNonImage } from './validateNonImage';

export const validateFile = (file: QueuedIntakeFileInfo, upload: UploadData, georef: GeorefData | undefined) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  file.isBeingValidated = true;

  if (file.fileCategory === 'non-image') {
    return validateNonImage(file, upload);
  } else {
    return validateImage(file, upload, georef);
  }
};
